export const PWA_INSTALLATION_GUIDE = "pwa-installation-guide"
export const DEVICE_ID = "deviceId"
export const WEB_PUSH_SUBSCRIBED_TIME = "web-push-subscribed-time"
export const LAST_SUBSCRIPTION_EXPIRY_REMINDER = "last-subscription-expiry-reminder"
